import { useEffect } from "react";
import { create } from "zustand";

const ORGANIZATION_HOST = [
  "staging.myconnect.ai",
  "prod.myconnect.ai",
  "localhost:3000",
  // "haa.myconnect.ai", // explicitly excluded
];

interface IModalResult {
  env?: "dev" | "stg" | "hbaw" | "hbas" | "ml";
  module?: "conference" | "organization";
  packageType?: "basic" | "premium";
}

const useEnvironmentStore = create<IModalResult>((set) => ({}));

export default useEnvironmentStore;

export const useInitiateEnv = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const subdomain = window?.location?.host?.split?.(".")?.[0];
      if (subdomain === "ml" || subdomain === "milkenscholars") {
        setEnvUsecase("ml");
      } else if (subdomain === "dev") {
        setEnvUsecase("dev");
      } else if (subdomain === "stg") {
        setEnvUsecase("stg");
      } else if (subdomain === "hbaw") {
        setEnvUsecase("hbaw");
      } else if (subdomain === "hbas") {
        setEnvUsecase("hbas");
      } else {
        setEnvUsecase("dev");
      }
    }
  }, []);
};

export const useInitiateModule = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const currentHost = window.location.host;
      if (currentHost.endsWith(".amplifyapp.com")) {
        setModuleUsecase("organization");
        return;
      }
      const isOrganization = ORGANIZATION_HOST.includes(currentHost);
      const module = isOrganization ? "organization" : "conference";
      setModuleUsecase(module);
    }
  }, []);
};

export const useInitiatePackageType = () => {
  useEffect(() => {
    setPackageType("basic");
  }, []);
};

export const setEnvUsecase = (env: IModalResult["env"]) => {
  useEnvironmentStore.setState((prev) => ({ ...prev, env }));
};

export const setModuleUsecase = (module: IModalResult["module"]) => {
  useEnvironmentStore.setState((prev) => ({ ...prev, module }));
};

export const setPackageType = (packageType: IModalResult["packageType"]) => {
  useEnvironmentStore.setState((prev) => ({ ...prev, packageType }));
};
